import { SERVICES } from "../../configs/constants";

export default {
  display: true,
  title: "Comptabilité",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Exports",
      icon: "ndf",
      id: "export",
      component: "",
      path: "/accounting/exports",
      onClick: "",
      minRole: 2
    },
    {
      label: "Validation Comptabilité",
      icon: "ndf",
      id: "expenseValidation",
      component: "",
      path: "/accounting/validation",
      onClick: "",
      minRole: 2
    },
    {
      label: "IBAN",
      icon: "rdv",
      id: "iban",
      component: "",
      path: "/accounting/ribs",
      onClick: "",
      minRole: 2
    },
    {
      label: "Barème panier repas",
      icon: "pdc",
      id: "mealpackageupdate",
      component: "",
      path: "/accounting/mealpackageupdate",
      onClick: "",
      minRole: 2
    },
    // {
    //   label: "Erreur compte de tiers",
    //   icon: "pdc",
    //   id: "duplicateduser",
    //   component: "",
    //   path: "/accounting/duplicateduser",
    //   onClick: "",
    //   minRole: 2
    // },
    {
      label: "NDF",
      icon: "pdc",
      id: "expenseReports",
      component: "",
      path: "/accounting/expenseReports",
      onClick: "",
      minRole: 4
      // service: SERVICES.NDF
    },
    {
      label: "Virements",
      icon: "pdc",
      id: "transfers",
      component: "",
      path: "/accounting/transfers",
      onClick: "",
      minRole: 2,
      service: SERVICES.Virement
    }
  ]
};



// WEBPACK FOOTER //
// src/pages/accounting/Menu.js